<h2 class="font-bold text-xl" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>
